import { Box } from '@mui/material';
import { resolveQixitAuthenticatorIconUrl } from '@summa/mfa-login';

/** Same Qixit mark as the mailbox login and MFA screens. */
export default function QixitLogo({ size = 56, marginBottom = 1 }: { size?: number; marginBottom?: number }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mb: marginBottom }} data-testid="qixit-auth-logo">
      <Box
        component="img"
        src={resolveQixitAuthenticatorIconUrl(true)}
        alt="Qixit"
        sx={{ width: size, height: size, objectFit: 'contain' }}
        onError={(e) => {
          const el = e.currentTarget as HTMLImageElement;
          const fallback = resolveQixitAuthenticatorIconUrl(false);
          if (el.src !== fallback) el.src = fallback;
        }}
      />
    </Box>
  );
}
